<template>
    <div class="menu-modal-container">
        <div class="menu-modal-content menu-modal-content-background-default">
            <div class="menu-modal-content-header">
                UMA
            </div>
            <div class="menu-modal-content-body">
                <div class="menu-modal-content-title">
                    <div class="menu-modal-icon menu-modal-icon-success">
                        <span class="mdi mdi-help"></span>
                    </div>
                    <div class="menu-modal-content-title-text">
                        <p>Seleccione la orden a unir</p>
                    </div>
                </div>
                <div class="menu-modal-main-section">
                    <div class="menu-modal-input-container">
                        <div class="menu-modal-input-container-row">
                            <select class="menu-modal-input-general menu-modal-input-select" v-model="selectedOrderReferenceId">
                                <option disabled value="0">Seleccione una orden</option>
                                <option v-for="option in orderReferenceOptions" :key="option.id" :value="option.id">
                                    {{ option.label }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="menu-btn-modal-container">
                    <button :class="isSelectedOrderReferenceIdOkValueClass" :disabled="!isSelectedOrderReferenceIdOkValue"  @click="merge">Unir orden</button>
                    <button class="menu-modal-btn menu-modal-cancel-btn" @click="closeModal">Cancelar</button>
                </div>
            </div>
        </div>
        <transition name="slide-fade">
            <WarningModal 
                v-if="showWarning"
                :warningMessage="warningMessage"
                :closeWarning="closeWarning"
            />
        </transition>  
    </div>
</template>

<script>
import WarningModal from '../../../../../common/components/modals/WarningModal.vue';
import { showCustomSuccessSweetAlert, showCustomErrorSweetAlert } from '../../../../../common/utils';
import axios from 'axios';
export default {
    name: "MergeOrderReferenceButtonActionModal",
    components: {
        WarningModal
    },
    props: {
        orderReference: {
            type: Object,
            required: true,
        },
        endOfAction: {
            type: Function,
            required: true,
        },
        closeModal: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            selectedOrderReferenceId: 0,
            showWarning: false,
            warningMessage: '',
        }
    },
    methods: {
        openWarning(message) {
            this.warningMessage = message;
            this.showWarning = true;
        },
        closeWarning() {
            this.showWarning = false;
            this.warningMessage = '';
        },
        merge() {
            if (!this.selectedOrderReferenceIdCheck()) return;
            this.endOfAction();
            axios.get(`/api/order-reference/merge/${this.orderReference.id}/${this.selectedOrderReferenceId}`)
                .then(res => {
                    showCustomSuccessSweetAlert('Se ha unido correctamente');
                })
                .catch(error => {
                    showCustomErrorSweetAlert(error.response.data);
                })
        },
        selectedOrderReferenceIdCheck() {
            if(this.selectedOrderReferenceId == 0) {
                this.openWarning('Por favor, seleccione una orden para continuar')
                return false;
            }
            return true;
        }
    },
    computed: {
        orderReferenceOptions() {
            return this.orderReference.divisions
                .filter(copy => copy.id !== this.orderReference.id && copy.order_state_id === 1)
                .map(o => ({ id: o.id, label: `${o.real_quantity} cajas` }));
        },
        isSelectedOrderReferenceIdOkValue() {
            return this.selectedOrderReferenceId > 0;
        },
        isSelectedOrderReferenceIdOkValueClass() {
            return this.isSelectedOrderReferenceIdOkValue ? 'menu-modal-btn menu-modal-confirm-btn' : 'menu-modal-btn menu-modal-confirm-btn-disabled';
        },
    }
};
</script>